import React, { useCallback, useContext, useMemo } from "react";
import { DNRDModelX } from "./utils";
import { AnyAction } from "redux";
import { AppModule, BootParams } from "@10x/coreapp/AppModule";
import { dispatch } from "@my-dld/utils/StoreUtils";
import { useAppSelector } from "@my-dld/utils/Utils";

export interface IRegDataContext {
	profile?: DNRDModelX;
}

export interface IRegContext extends IRegDataContext {
	setProfile: ( profile: DNRDModelX ) => void;
}

const def: IRegContext = {
	setProfile: () => {
	},
};
const RegContext = React.createContext( def );

export { RegContext };

export function useRegContext() {
	return useContext( RegContext );
}

export function RegContextWrapper( props: React.PropsWithChildren<any> ) {
	const profile = useAppSelector( x => x.Registration.profile );
	const setProfile = useCallback( ( profile: DNRDModelX ) => {
		dispatch( REG_UPDATE_PROFILE, profile );
	}, [] );
	const ctxValue = useMemo( () => {
		return {
			profile: profile,
			setProfile: setProfile,
		} as IRegContext;
	}, [ profile, setProfile ] );

	return <RegContext.Provider value={ ctxValue }>
		{ props.children }
	</RegContext.Provider>;
}


export const REG_INIT = "REG_INIT";
export const REG_UPDATE_PROFILE = "REG_UPDATE_PROFILE";
export const REG_DONE = "REG_DONE";

export function initRegistration() {
	dispatch( REG_INIT );
}

export function doneRegistration() {
	dispatch( REG_DONE );
}

export function RegReducer( state: IRegDataContext = def, action: AnyAction ) {

	switch ( action.type ) {
		case REG_INIT:
			return { profile: undefined };

		case REG_UPDATE_PROFILE:
			return { ...state, profile: action.payload };

		case REG_DONE:
			return { profile: undefined };

		default:
			return state;
	}
}

declare module "@my-dld/reducers/store" {
	interface IStore {
		Registration: IRegDataContext,
	}
}

class RegModule implements AppModule {
	registerModule( bootParams: BootParams ): void {
		bootParams.storeService.registerReducer( "Registration", RegReducer );
	}
}

export const regModule = new RegModule();
